import React, { useState } from "react";
import HeaderBottom from "../assets/header-bottom-shap.png";
import fromToIcon from "../assets/from-to-trip.png"; 
import tripRootIcon from "../assets/trip-root-icons.png"; 
import heartIcon from "../assets/heart.png";
import { Link } from "react-router-dom";
import still02 from "../assets/still-02.png";
import heart from "../assets/heart.png";
import FlightDetailsModal from "../components/FlightDetailsModal";
import { useTranslation } from 'react-i18next'

const Trip = () => {
  const [showModal, setShowModal] = useState(false);
  
    const { t } = useTranslation();

  return (
    <main className="main position-relative">
      <div className="bottom-main-shap position-absolute top-0">
        <img src={HeaderBottom} alt="" />
      </div>
      <div class="trip-main-sec mt-0-trip pt-lg-5 position-relative z-1 mb-5">
        <div className="btn-filter-box d-lg-none ">
            <button className="btn btn-menu border-0" type="button" data-bs-toggle="offcanvas" data-bs-target="#offcanvasExampleFilterHotal" aria-controls="offcanvasExample">
                {t("filterTitle")}
                <i className="fas fa-bars"></i>
            </button>
        </div>
        <div class="container">
          <div class="row">
            <div class="col-lg-4 col-md-12 mb-lg-0 mb-4">
               <div className="offcanvas offcanvas-start filter-box-sec" tabIndex="-1" id="offcanvasExampleFilterHotal" aria-labelledby="offcanvasExampleLabel">
                  <div className="trip-left-sec">
                  <button type="button" className="btn-close d-lg-none d-block" data-bs-dismiss="offcanvas" aria-label="Close"></button>
                  <div className="heading">
                    <h4>{t("filterResults")}</h4>
                  </div>
                    <div className="list-trip">
                      <h4>{t("yourFavorites")}</h4>
                      <ul className="list-unstyled p-0 m-0">
                        <li>
                          <div className="form-check">
                            <input className="form-check-input" type="checkbox" id="favoriteHotels"/>
                            <label className="form-check-label" htmlFor="favoriteHotels">{t("hotels")} </label>
                          </div>
                        </li>
                        <li>
                          <div className="form-check">
                            <input className="form-check-input" type="checkbox" id="favoriteFlights"/>
                            <label className="form-check-label" htmlFor="favoriteFlights"> {t("flights")} </label>
                          </div>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
            </div>
            <div class="col-lg-8 col-md-12">
              <div class="trip-right-sec">
                  <div className="trip-details d-flex align-items-center mb-3 flex-lg-nowrap flex-wrap">
                    <div className="left-details">
                      <ul className="list-btn-trip list-unstyled p-0 m-0 d-flex align-items-center gap-2">
                        <li>
                          <Link to="#" className="btn btn-orange">
                          {t("bestCheapest")}
                          </Link>
                        </li>
                        <li>
                          <Link to="#" className="btn btn-parrot">
                          {t("direct")}
                          </Link>
                        </li>
                        <li>
                          <Link to="#" className="btn btn-border border-blue">
                          {t("flexibleTicket")}
                          </Link>
                        </li>
                      </ul>

                      <div className="details-trip-box d-flex align-items-center gap-3">
                        <div className="left-from-trip">
                          <div className="trip-text-icons-box d-flex align-items-center gap-2">
                            <div className="icons">
                              <img src={fromToIcon} alt={t("fromIconAlt")} />
                            </div>
                            <div className="text">
                              <h6>5:20 AM</h6>
                              <span className="text-sub">{t("fromAirport")}</span>
                            </div>
                          </div>
                          <div className="trip-text-icons-box d-flex align-items-center gap-2">
                            <div className="icons">
                              <img src={fromToIcon} alt={t("toIconAlt")} />
                            </div>
                            <div className="text">
                              <h6>9:15 AM</h6>
                              <span className="text-sub">{t("toAirport")}</span>
                            </div>
                          </div>
                        </div>

                        <div className="mid-direct-trip">
                          <div className="trip-icons">
                            <img src={tripRootIcon} alt={t("tripIconAlt")} />
                          </div>
                          <div className="trip-icons">
                            <Link to="#" className="btn btn-parrot">
                              {t("direct")}
                            </Link>
                          </div>
                          <div className="trip-icons">
                            <img src={tripRootIcon} alt={t("tripIconAlt")} />
                          </div>
                        </div>

                        <div className="right-to-trip">
                          <div className="trip-text-icons-box d-flex align-items-center gap-2">
                            <div className="text">
                              <h6>5:20 AM</h6>
                              <span className="text-sub">{t("fromAirport")}</span>
                            </div>
                          </div>
                          <div className="trip-text-icons-box d-flex align-items-center gap-2">
                            <div className="text">
                              <h6>9:15 AM</h6>
                              <span className="text-sub">{t("toAirport")}</span>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="trip-vec-box">
                      <h6>{t("airIndia")}</h6>
                      </div>
                    </div>

                    <div className="right-details">
                      <div className="right-price-heart-details text-center">
                        <div className="price-box d-flex justify-content-center">
                          <span className="heart-icons">
                            <img src={heartIcon} alt={t("favorite")} />
                          </span>
                          {t("INR")} 67,170.00
                        </div>

                        <div className="btn-box">
                          <Link to="/flights" className="btn btn-primary">
                            {t("viewDetails")}
                          </Link>
                        </div>

                        {/* Explore Ticket Options */}
                        <div className="drop-box-price">
                          <Link to="#" className="btn-text d-flex align-items-center gap-2" onClick={() => setShowModal(true)}>
                            <span>{t("exploreOptions")}</span>
                            <svg width="15" height="9" viewBox="0 0 15 9" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 1L7.5 7L14 1" stroke="#33A7F6" strokeWidth="2" strokeLinecap="round" />
                            </svg>
                          </Link>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="trip-details trip-review-details p-12 d-flex mb-3 flex-lg-nowrap flex-wrap">
                    <div className="left-review-details d-flex flex-wrap gap-2">
                      <div className="img-review">
                        <img src={still02} alt="Hotel" />
                      </div>
                      <div className="text-review">
                        <h2>{t("hotelName")}</h2>
                        <div className="heart-text d-flex align-items-center gap-2">
                          <span>
                            {t("hotelLocation")}
                          </span>
                          <span className="img">
                            <img src={heart} alt={t("favorite")} />
                          </span>
                        </div>
                        <div className="btn-box-mid">
                          <Link to="#" className="btn btn-parrot">
                            {t("limitedDeal")}
                          </Link>
                        </div>
                        <div className="room-details">
                          <p>{t("doubleRoom")}</p>
                          <ul className="list-item-dot">
                            <li>{t("oneFullBed")}</li>
                          </ul>
                          <p>{t("noPrepayment")}</p>
                        </div>
                      </div>
                    </div>

                    <div className="right-review-details">
                      <div className="review-right-com d-flex flex-column h-100 text-end">
                        <div className="top-box-review">
                          <div className="room-servic">
                            <span className="review-text">{t("excellentReviews")}</span>
                            <span className="review-btn"></span>
                          </div>
                        </div>
                        <div className="bottom-box-price-details mt-auto">
                          <div className="bottom-box">
                            <ul className="top-adult list-unstyled p-0 m-0 d-flex align-items-center gap-1 justify-content-end">
                              <li>{t("oneNight")}, </li>
                              <li>{t("twoAdults")}</li>
                            </ul>
                            <ul className="price-details list-unstyled p-0 m-0 d-flex align-items-center gap-1 justify-content-end">
                              <li className="old-price">{t("oldPrice", { price: "₹ 3,306" })}</li>
                              <li className="current-price">{t("currentPrice", { price: "₹ 1,587" })}</li>
                            </ul>
                            <span>+{t("taxesAndFees", { price: "₹ 190" })}</span>
                            <Link to="/hotel" className="btn btn-primary">
                              {t("viewDetails")}
                            </Link>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  
                  <div className="trip-details d-flex align-items-center mb-3 flex-lg-nowrap flex-wrap">
                    <div className="left-details">
                      <ul className="list-btn-trip list-unstyled p-0 m-0 d-flex align-items-center gap-2">
                        <li>
                          <Link to="#" className="btn btn-orange">
                            {t("bestCheapest")}
                          </Link>
                        </li>
                        <li>
                          <Link to="#" className="btn btn-parrot">
                            {t("direct")}
                          </Link>
                        </li>
                        <li>
                          <Link to="#" className="btn btn-border border-blue">
                            {t("flexibleTicket")}
                          </Link>
                        </li>
                      </ul>

                      <div className="details-trip-box d-flex align-items-center gap-3">
                        <div className="left-from-trip">
                          <div className="trip-text-icons-box d-flex align-items-center gap-2">
                            <div className="icons">
                              <img src={fromToIcon} alt={t("fromIconAlt")} />
                            </div>
                            <div className="text">
                              <h6>5:20 AM</h6>
                              <span className="text-sub">{t("fromAirport")}</span>
                            </div>
                          </div>
                          <div className="trip-text-icons-box d-flex align-items-center gap-2">
                            <div className="icons">
                              <img src={fromToIcon} alt={t("toIconAlt")} />
                            </div>
                            <div className="text">
                              <h6>9:15 AM</h6>
                              <span className="text-sub">{t("toAirport")}</span>
                            </div>
                          </div>
                        </div>

                        <div className="mid-direct-trip">
                          <div className="trip-icons">
                            <img src={tripRootIcon} alt={t("tripIconAlt")} />
                          </div>
                          <div className="trip-icons">
                            <Link to="#" className="btn btn-parrot">
                              {t("direct")}
                            </Link>
                          </div>
                          <div className="trip-icons">
                            <img src={tripRootIcon} alt={t("tripIconAlt")} />
                          </div>
                        </div>

                        <div className="right-to-trip">
                          <div className="trip-text-icons-box d-flex align-items-center gap-2">
                            <div className="text">
                              <h6>5:20 AM</h6>
                              <span className="text-sub">{t("fromAirport")}</span>
                            </div>
                          </div>
                          <div className="trip-text-icons-box d-flex align-items-center gap-2">
                            <div className="text">
                              <h6>9:15 AM</h6>
                              <span className="text-sub">{t("toAirport")}</span>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="trip-vec-box">
                        <h6>{t("airIndia")}</h6>
                      </div>
                    </div>

                    <div className="right-details">
                      <div className="right-price-heart-details text-center">
                        <div className="price-box d-flex justify-content-center">
                          <span className="heart-icons">
                            <img src={heartIcon} alt={t("favorite")} />
                          </span>
                          {t("INR")} 67,170.00
                        </div>

                        <div className="btn-box">
                          <Link to="/flights" className="btn btn-primary">
                            {t("viewDetails")}
                          </Link>
                        </div>

                        {/* Explore Ticket Options */}
                        <div className="drop-box-price">
                          <Link to="#" className="btn-text d-flex align-items-center gap-2" onClick={() => setShowModal(true)}>
                            <span>{t("exploreOptions")}</span>
                            <svg width="15" height="9" viewBox="0 0 15 9" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 1L7.5 7L14 1" stroke="#33A7F6" strokeWidth="2" strokeLinecap="round" />
                            </svg>
                          </Link>
                        </div>
                      </div>
                    </div>
                  </div>

              </div>
            </div>
          </div>
        </div>
      </div>
    
      <FlightDetailsModal show={showModal} handleClose={() => setShowModal(false)} />
    </main>
  );
};

export default Trip;
